// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"Checkbox-module--Checkbox--dKYFm","Link":"Checkbox-module--Link--2W1Vc"};